import { Subject } from "rxjs";
import { DynamicPromo, DynamicPromoInfo } from "./dyanmicPromo";

export abstract class DynamicPromoRepository {
  updateDynamicPromo: (
    dynamicPromoInfo: DynamicPromoInfo,
  ) => Promise<DynamicPromo>;

  createDynamicPromo: (dynamicPromo: DynamicPromo) => Promise<DynamicPromo>;

  getDynamicPromos: () => Promise<DynamicPromo[]>;

  getDynamicPromo: (id: string) => Promise<DynamicPromo>;

  deleteDynamicPromo: (id: string) => Promise<void>;

  getTimespotDefaults: () => Promise<
    Array<{ type: number; name: string; defaultText: string }>
  >;
}
